import React from 'react'
import { QuickLinks } from 'component-library/navigation/QuickLinks/QuickLinks'
import { createRegisterableComponent } from 'common/routing/page-definition'
import { NavItem } from 'common/navigation'

export interface QuickLinksRouteProps {
    links: NavItem[]
    hasBackgroundFill?: boolean
}

export const QuickLinksRegistration = createRegisterableComponent(
    'quick-links',
    (props: QuickLinksRouteProps, services) => <QuickLinks {...props} onEvent={services.onEvent} />
)
